/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const Text = ({ size, color, className }) => {
  return <div className={`text ${size} color-${color} ${className}`} />;
};

Text.propTypes = {
  size: PropTypes.oneOf(["headline", "caption", "body"]),
  color: PropTypes.oneOf(["primary", "secondary"]),
};
